import { PortalButtonList } from '../button-list';

export class StakeholderButton extends PortalButtonList {
  name = 'Stakeholders'
}